const Home = () => {
  return <div>Home</div>
}

Home.displayName = 'Home'
export default Home
